import { get, post, put, del } from '@/utils/apiClient';
import { CableSpecs } from '@/types/copperPrice.interface';

export const getCopperPriceHistory = async (from: string, to: string) => {
  const apiResponse = await get(`/copper/historical-prices?from=${from}&to=${to}`);
  return apiResponse;
};

export const getCableSpecs = async () => {
  const apiResponse = await get(`/copper/cable-specifications`);
  return apiResponse;
};

export const getCableSpecsById = async (id: string) => {
  const apiResponse = await get(`/copper/cable-specifications/${id}`);
  return apiResponse;
};

export const createCableSpecs = async (data: CableSpecs) => {
  const apiResponse = await post(`/copper/cable-specifications`, data);
  return apiResponse;
};

export const updateCableSpecs = async (id: string, data: CableSpecs) => {
  const apiResponse = await put(`/copper/cable-specifications/${id}`, data);
  return apiResponse;
};

export const deleteCableSpecs = async (id: string) => {
  const apiResponse = await del(`/copper/cable-specifications/${id}`);
  return apiResponse;
};
